import React, { useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { changesApi } from '../../../services/changesApi';
import ChangeDetailSummaryConfigurator from './ChangeDetailSummaryConfigurator';
import ChangeFormFieldBuilder from './ChangeFormFieldBuilder';

const ChangeCreateFormBuilder: React.FC = () => {
  const [showDetailSummary, setShowDetailSummary] = useState(false);
  const api = useMemo(
    () => ({
      load: changesApi.getFormSchema,
      createField: changesApi.createFormField,
      updateField: changesApi.updateFormField,
      deleteField: changesApi.deleteFormField,
      reorderFields: changesApi.reorderFormFields,
    }),
    [],
  );
  return (
    <>
      <div className="d-flex flex-wrap justify-content-end gap-2 mb-3">
        <Button variant="outline-primary" onClick={() => setShowDetailSummary(true)}>
          Configurar resumo do detalhe
        </Button>
      </div>
      <ChangeFormFieldBuilder
        heading="Formulário de criação"
        description="Segure o ícone ⋮⋮ e arraste para cima ou para baixo para mudar a ordem. Campos com selo sistema não somem da modal. A flag de dispensa de checklist vale para qualquer campo preenchido — o padrão é o número do problema (PRB), sem cravar só esse caso no código."
        api={api}
        allowSkipChecklist
        allowDateRevisionHistory
      />
      <ChangeDetailSummaryConfigurator
        modal
        show={showDetailSummary}
        onHide={() => setShowDetailSummary(false)}
      />
    </>
  );
};

export default ChangeCreateFormBuilder;
